/** Лиги (SPEC §6.2, §6.3). 10 ступеней, личные — по неделям, залы — по месяцам. */
export const LEAGUES = [
    { tier: 1, name: 'Железо', accusative: 'Железо', title: 'Железная лига', icon: '01-iron' },
    { tier: 2, name: 'Бронза', accusative: 'Бронзу', title: 'Бронзовая лига', icon: '02-bronze' },
    { tier: 3, name: 'Серебро', accusative: 'Серебро', title: 'Серебряная лига', icon: '03-silver' },
    { tier: 4, name: 'Золото', accusative: 'Золото', title: 'Золотая лига', icon: '04-gold' },
    { tier: 5, name: 'Платина', accusative: 'Платину', title: 'Платиновая лига', icon: '05-platinum' },
    { tier: 6, name: 'Изумруд', accusative: 'Изумруд', title: 'Изумрудная лига', icon: '06-emerald' },
    { tier: 7, name: 'Сапфир', accusative: 'Сапфир', title: 'Сапфировая лига', icon: '07-sapphire' },
    { tier: 8, name: 'Рубин', accusative: 'Рубин', title: 'Рубиновая лига', icon: '08-ruby' },
    { tier: 9, name: 'Аметист', accusative: 'Аметист', title: 'Аметистовая лига', icon: '09-amethyst' },
    { tier: 10, name: 'Алмаз', accusative: 'Алмаз', title: 'Алмазная лига', icon: '10-diamond' },
];
export const MIN_TIER = 1;
export const MAX_TIER = 10;
export const PERSONAL_GROUP_SIZE = 30;
export const PERSONAL_PROMOTE = 7;
export const PERSONAL_RELEGATE = 5;
export const GYM_GROUP_SIZE = 12;
export const GYM_PROMOTE = 3;
export const GYM_RELEGATE = 3;
export function leagueByTier(tier) {
    const clamped = Math.min(MAX_TIER, Math.max(MIN_TIER, Math.round(tier)));
    return LEAGUES[clamped - 1];
}
export function leagueIconPath(tier) {
    return `/assets/leagues/${leagueByTier(tier).icon}.webp`;
}
export function groupLimits(kind) {
    return kind === 'personal'
        ? { size: PERSONAL_GROUP_SIZE, promote: PERSONAL_PROMOTE, relegate: PERSONAL_RELEGATE }
        : { size: GYM_GROUP_SIZE, promote: GYM_PROMOTE, relegate: GYM_RELEGATE };
}
/**
 * Зона участника по месту. В Железе не вылетают, в Алмазе некуда подниматься —
 * там топ-3 получают значок.
 */
export function zoneFor(rank, size, tier, kind) {
    const { promote, relegate } = groupLimits(kind);
    if (tier < MAX_TIER && rank <= promote)
        return 'up';
    if (tier === MAX_TIER && rank <= 3)
        return 'up';
    if (tier > MIN_TIER && rank > size - relegate)
        return 'down';
    return 'stay';
}
export function zoneLabel(zone, kind, tier) {
    const subject = kind === 'gym' ? 'Зал' : 'Вы';
    if (zone === 'up') {
        if (tier === MAX_TIER)
            return `${subject} в зоне значка недели`;
        return `${subject} в зоне повышения`;
    }
    if (zone === 'down')
        return `${subject} в зоне вылета`;
    return kind === 'gym' ? 'Зал сохраняет лигу' : 'Вы сохраняете лигу';
}
/** «Топ-7 переходят в Платину, последние 5 — опускаются в Серебро.» */
export function transitionRule(tier, kind) {
    const { promote, relegate } = groupLimits(kind);
    const who = kind === 'gym' ? `Топ-${promote} зала` : `Топ-${promote}`;
    const up = tier < MAX_TIER
        ? `${who} переходят в ${leagueByTier(tier + 1).accusative}`
        : `Топ-3 недели получают значок`;
    const down = tier > MIN_TIER
        ? `последние ${relegate} — опускаются в ${leagueByTier(tier - 1).accusative}`
        : 'из Железа не вылетают';
    return `${up}, ${down}.`;
}
/** Итог периода: куда переводим участника. */
export function outcomeFor(rank, size, tier, kind) {
    const zone = zoneFor(rank, size, tier, kind);
    if (zone === 'up' && tier < MAX_TIER)
        return { outcome: 'up', nextTier: tier + 1 };
    if (zone === 'down' && tier > MIN_TIER)
        return { outcome: 'down', nextTier: tier - 1 };
    return { outcome: 'stay', nextTier: tier };
}
//# sourceMappingURL=leagues.js.map